module dg.objects {

    export class ReferenceDisplayerController extends PropertyDisplayerControllerBase<dg.domain.model.DomainModelRefInfo> {

        public navLink: restfulApi.Link;

        protected init() {
            this.setNavLink();
        }

        setNavLink() {
            if (this.propMeta.links) {
                this.navLink = this.propMeta.links.details;
                //(this.propMeta as any).hasErrors = true;
                if (!this.navLink && this.options && this.options.navigateToEdit) {
                    this.navLink = this.propMeta.links.edit;
                }
            }
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(ReferenceDisplayerController, 'referenceDisplayer', {
        //templateUrl: '/digmo/src/objects/properties/lookup/reference-displayer.html',
        templateUrl: ($element, $attrs: any, objectService: dg.objects.ObjectService) => {
            let templateType = $attrs.templateType;
            let templateUrl = '/digmo/src/objects/properties/lookup/reference-displayer.html';
            if (!templateType) {
                templateType = 'lookup/reference-displayer';
            }
            else {

                templateType = templateType.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);

                if (objectService.templateExists(templateType)) {
                    templateUrl = `/app/src/templates/${templateType}-template.html`;
                } 
            }
            return templateUrl;
        }
    });

    //angular.module('dg.objects')
    //    .component('referenceDisplayer', {
    //        bindings: {
    //            value: '<',
    //            propMeta: '<',
    //            options: '<?'
    //        },
    //        controller: ReferenceDisplayerController,
            
    //    });
}